import { useFish } from "../../contexts/fish";
import Select from 'react-select';
import { useEffect, useState } from 'react';
import service from '../../service';
import { useModal } from "../../contexts/modal";

const TagMultiSelectDropdown = ({ fishId }) => {
  const [options, setOptions] = useState([]);
  const { fishTags, readFishTags, readSegmentsForFish } = useFish();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [originalTags, setOriginalTags] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const { closeModal } = useModal();

  useEffect(() => {
    const fetchAllTags = async () => {
      const allTags = await service.readAllTags();
      
      // Convert all tags to options format
      const allTagOptions = allTags.map(tag => ({
        value: tag.id,
        label: tag.name
      }));
      
      // Set current fish tags as selected options
      const currentFishTags = fishTags[fishId].map(tag => ({
        value: tag.id,
        label: tag.name
      }));
      
      setOptions(allTagOptions);
      setSelectedOptions(currentFishTags);
      setOriginalTags(currentFishTags);
    }
    fetchAllTags();
  }, [fishTags, fishId]); 

  const handleChange = (newValue) => {
    setSelectedOptions(newValue || []);
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      // Compare originalTags with selectedOptions to determine changes
      const originalTagIds = new Set(originalTags.map(tag => tag.value));
      const selectedTagIds = new Set(selectedOptions.map(tag => tag.value));

      const tagsToAdd = selectedOptions
        .filter(tag => !originalTagIds.has(tag.value))
        .map(tag => tag.value);

      const tagsToRemove = originalTags
        .filter(tag => !selectedTagIds.has(tag.value))
        .map(tag => tag.value);
  
      if (tagsToAdd.length > 0) {
        await service.addManyTagsToFish(fishId, tagsToAdd);
      }
      if (tagsToRemove.length > 0) {
        await service.removeManyTagsFromFish(fishId, tagsToRemove);
      }
      await readFishTags(fishId);
      await readSegmentsForFish(fishId);
      
      setOriginalTags(selectedOptions);
    } catch (error) {
      console.error('Failed to update tags:', error);
    } finally {
      setIsSaving(false);
      closeModal()
    }
  };

  const hasChanges = () => {
    const originalTagIds = new Set(originalTags.map(tag => tag.value));
    const selectedTagIds = new Set(selectedOptions.map(tag => tag.value));
    
    // Check if any tags were added or removed
    return (
      originalTags.length !== selectedOptions.length ||
      originalTags.some(tag => !selectedTagIds.has(tag.value)) ||
      selectedOptions.some(tag => !originalTagIds.has(tag.value))
    );
  };

  return (
    <div>
      <Select
        isMulti
        options={options}
        value={selectedOptions}
        onChange={handleChange}
        placeholder="Select tags..."
        isClearable={false}
        isSearchable
        classNamePrefix="select"
        noOptionsMessage={() => "No tags found"}
      />
      <button 
        onClick={handleSave}
        disabled={!hasChanges() || isSaving}
        className={`mt-4 px-4 py-2 rounded text-white ${
          hasChanges() && !isSaving ? "bg-blue-500 hover:bg-blue-600" : "bg-gray-400"
        }`}
      >
        {isSaving ? 'Saving...' : 'Update Tags'}
      </button>
    </div>
  );
};

export default TagMultiSelectDropdown;
